export default function getFormatedDate(inputDate?: Date | null | undefined, locale = 'en-US') : string {
    if (inputDate) {
        return inputDate.toLocaleDateString(locale, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    }
    return ""
}